(() => {
  const initSlider = (root) => {
    if (root.dataset.shPreOrderReady === 'true') return;
    root.dataset.shPreOrderReady = 'true';

    const track = root.querySelector('.sh-pre-order-products__track');
    const dotsWrap = root.querySelector('[data-sh-pre-order-dots]');
    if (!track || !dotsWrap) return;

    const dots = Array.from(dotsWrap.querySelectorAll('.sh-pre-order-products__dot'));
    const items = Array.from(track.querySelectorAll('.sh-pre-order-products__item'));
    const pageCount = Math.max(
      1,
      Number(root.getAttribute('data-page-count') || dots.length || 1)
    );
    if (!items.length || !dots.length) return;

    const setActive = (index) => {
      const safeIndex = Math.max(0, Math.min(index, pageCount - 1));
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === safeIndex);
      });
    };

    const getPageScrollLeft = (pageIndex) => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      if (pageCount <= 1 || maxScroll <= 1) return 0;
      return (maxScroll / (pageCount - 1)) * pageIndex;
    };

    const getActiveIndex = () => {
      const scrollLeft = track.scrollLeft;
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 1 || pageCount <= 1) return 0;
      if (scrollLeft >= maxScroll - 2) return pageCount - 1;

      const ratio = scrollLeft / maxScroll;
      return Math.round(ratio * (pageCount - 1));
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.getAttribute('data-index') || 0);
        track.scrollTo({ left: getPageScrollLeft(index), behavior: 'smooth' });
        setActive(index);
      });
    });

    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        setActive(getActiveIndex());
        ticking = false;
      });
    }, { passive: true });

    setActive(0);
  };

  const refreshCarousel = (carousel) => {
    if (!carousel) return;
    if (typeof carousel.refresh === 'function') {
      carousel.refresh();
      return;
    }
    if (typeof carousel.init === 'function' && !carousel.hasAttribute('loaded')) {
      carousel.init();
    }
  };

  const getMainTrack = (modal) => {
    const mainSlider = modal.querySelector('[data-sh-pre-order-qv-main-slider]');
    return mainSlider ? mainSlider.querySelector('.slider') : null;
  };

  const getMainSlides = (modal) => Array.from(
    modal.querySelectorAll('[data-sh-pre-order-qv-main-slider] .slider__item')
  );

  const getThumbSlides = (modal) => Array.from(
    modal.querySelectorAll('[data-sh-pre-order-qv-thumbs] .slider__item')
  );

  const getClosestSlideIndex = (track, slides) => {
    if (!track || !slides.length) return 0;
    const scrollLeft = track.scrollLeft;
    let closestIndex = 0;
    let closestDistance = Infinity;

    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.offsetLeft - scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  };

  const syncActiveClasses = (modal, mediaId) => {
    const strMediaId = String(mediaId);

    getMainSlides(modal).forEach((item) => {
      item.classList.toggle('is-active', String(item.dataset.mediaId) === strMediaId);
    });

    getThumbSlides(modal).forEach((item) => {
      item.classList.toggle('is-active', String(item.dataset.mediaId) === strMediaId);
    });
  };

  const scrollThumbIntoView = (modal, mediaId) => {
    const thumbSlider = modal.querySelector('[data-sh-pre-order-qv-thumbs]');
    const thumbSlide = modal.querySelector(
      `[data-sh-pre-order-qv-thumbs] .slider__item[data-media-id="${mediaId}"]`
    );
    const thumbTrack = thumbSlider ? thumbSlider.querySelector('.slider') : null;
    if (!thumbTrack || !thumbSlide) return;

    const maxScroll = Math.max(0, thumbTrack.scrollWidth - thumbTrack.clientWidth);
    const target = thumbSlide.offsetLeft - (thumbTrack.clientWidth - thumbSlide.clientWidth) / 2;
    const left = Math.max(0, Math.min(target, maxScroll));
    thumbTrack.scrollTo({ left, behavior: 'smooth' });
  };

  const goToMedia = (modal, mediaId, { scrollMain = true, behavior = 'smooth' } = {}) => {
    if (!modal || mediaId == null) return;
    const strMediaId = String(mediaId);
    const track = getMainTrack(modal);
    const mainSlide = modal.querySelector(
      `[data-sh-pre-order-qv-main-slider] .slider__item[data-media-id="${strMediaId}"]`
    );

    modal._shQvLockMediaId = strMediaId;

    if (scrollMain && track && mainSlide) {
      track.scrollTo({ left: mainSlide.offsetLeft, behavior });
    }

    syncActiveClasses(modal, strMediaId);
    scrollThumbIntoView(modal, strMediaId);

    window.clearTimeout(modal._shQvLockTimer);
    modal._shQvLockTimer = window.setTimeout(() => {
      if (modal._shQvLockMediaId === strMediaId) {
        modal._shQvLockMediaId = null;
      }
    }, behavior === 'smooth' ? 450 : 50);
  };

  const syncFromMainScroll = (modal) => {
    if (modal._shQvLockMediaId) {
      syncActiveClasses(modal, modal._shQvLockMediaId);
      return;
    }

    const track = getMainTrack(modal);
    const slides = getMainSlides(modal);
    const index = getClosestSlideIndex(track, slides);
    const mediaId = slides[index] && slides[index].dataset.mediaId;
    if (!mediaId) return;

    syncActiveClasses(modal, mediaId);
    scrollThumbIntoView(modal, mediaId);
  };

  const resetGalleryToFirst = (modal) => {
    const firstSlide = getMainSlides(modal)[0];
    if (!firstSlide) return;
    goToMedia(modal, firstSlide.dataset.mediaId, { scrollMain: true, behavior: 'auto' });
  };

  const initQuickviewGallery = (modal) => {
    if (!modal || modal.dataset.shQvGalleryReady === 'true') return;
    modal.dataset.shQvGalleryReady = 'true';

    const mainSlider = modal.querySelector('[data-sh-pre-order-qv-main-slider]');
    const thumbSlider = modal.querySelector('[data-sh-pre-order-qv-thumbs]');
    const mainTrack = getMainTrack(modal);

    refreshCarousel(mainSlider);
    refreshCarousel(thumbSlider);

    if (mainTrack) {
      let ticking = false;
      mainTrack.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          syncFromMainScroll(modal);
          ticking = false;
        });
      }, { passive: true });
    }

    modal.querySelectorAll('[data-sh-pre-order-qv-thumbs] .thumbnail').forEach((thumb) => {
      thumb.addEventListener('click', (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        const item = thumb.closest('.slider__item');
        const mediaId = item && item.dataset.mediaId;
        if (!mediaId) return;
        goToMedia(modal, mediaId, { scrollMain: true, behavior: 'smooth' });
      });
    });
  };

  const prepareQuickviewOpen = (modal) => {
    if (!modal) return;
    initQuickviewGallery(modal);

    const mainSlider = modal.querySelector('[data-sh-pre-order-qv-main-slider]');
    const thumbSlider = modal.querySelector('[data-sh-pre-order-qv-thumbs]');

    requestAnimationFrame(() => {
      refreshCarousel(mainSlider);
      refreshCarousel(thumbSlider);
      resetGalleryToFirst(modal);

      requestAnimationFrame(() => {
        refreshCarousel(mainSlider);
        refreshCarousel(thumbSlider);
        resetGalleryToFirst(modal);
      });
    });
  };

  const initQuickviewOpeners = () => {
    document.querySelectorAll('[data-sh-pre-order-qv-open]').forEach((btn) => {
      if (btn.dataset.shQvBound === 'true') return;
      btn.dataset.shQvBound = 'true';

      btn.addEventListener('click', () => {
        const modalId = btn.getAttribute('data-sh-pre-order-qv-open');
        if (!modalId) return;
        const modal = document.getElementById(modalId);
        if (!modal || typeof modal.open !== 'function') return;
        prepareQuickviewOpen(modal);
        modal.open(btn);
      });
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-sh-pre-order-slider]').forEach((root) => {
      root.dataset.shPreOrderReady = 'false';
      initSlider(root);
    });
    initQuickviewOpeners();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
